export default () => ({
  categories         : [],
  myCategories       : [],
  myCategoriesCount  : 0,
  myDisciplinesCount : 0
});
